import {Component, Input, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {MessageToastService} from "../../../../service/message-toast.service";
import {ErrorMessageEnum} from "../../../../shared/enums/error-message.enum";
import {finalize, tap} from "rxjs";
import {ApiResponse} from "../../../../shared/model/response/ApiResponse";
import {AccountService} from "../../../../service/api/account.service";
import {SessionService} from "../../../../service/session.service";

@Component({
    selector: 'app-edit-profile',
    templateUrl: './edit-profile.component.html',
    standalone: false
})
export class EditProfileComponent implements OnInit {

  @Input('name') name : string
  firstname : string
  lastname : string

  form: FormGroup;
  formErrors: Map<string, string> = new Map();

  isLoading = false;

  constructor(
    private accountService: AccountService,
    private messageToastService: MessageToastService,
    private sessionService: SessionService
  ) {
  }

  ngOnInit(): void {

    this.setFirstAndLastname()
    this.initForm()
  }

  //todo temporary fix
  setFirstAndLastname(): void {
    const names = this.sessionService._displayName.value.split(" ")
    this.firstname = names[0]
    this.lastname = names[names.length - 1]
  }

  initForm(): void {
    const name = this.sessionService._displayName.value

    this.form = new FormGroup({
      "firstname": new FormControl(this.firstname, Validators.required),
      "lastname": new FormControl(this.lastname, Validators.required),
    });

  }

  onSubmit() {
    this.formErrors.clear()
    this.form.invalid ? this.displayFrontEndErrors() : this.onUpdateuserDetails()
  }

  onUpdateuserDetails() {
    this.isLoading = true
    this.accountService.updateAccount(this.form.value)
      .pipe(
        finalize(() => this.isLoading = false),
        tap({
            next: (response) => {
              this.messageToastService.success(response.message)

              const name = response.data?.firstname + ' ' + response.data?.lastname
              this.sessionService._displayName.next(name)
            },
            error: (err: ApiResponse<any>) => {
              this.formErrors = err?.formErrors ?? new Map()
              this.messageToastService.error(err.message)
            }
          }
        )
      )
      .subscribe()
  }

  private displayFrontEndErrors() {
    this.validateRequired('firstname')
    this.validateRequired('lastame')
  }

  private validateRequired(field: string) {
    if (this.form.get(field)?.hasError("required")) {
      this.formErrors.set(field, ErrorMessageEnum.requiredField)
    }
  }

}
